import { Routes, Route} from 'react-router-dom';
import DashboardScreen from '../app/screens/DashboardScreen';
import HomeScreen from '../app/screens/HomeScreen';
const AppRoutes = props => {
    return (
        <Routes>
            <Route path="/" element={ <HomeScreen /> }/>
            <Route path="/:key" element={ <DashboardScreen /> }/>
        </Routes>
    );
}
export default AppRoutes;